import { defineNuxtPlugin } from 'nuxt/app';
import type { NuxtApp } from 'nuxt/app';
import { findNodeIdIndexInArray, findIdIndexInArray, getResourcesFileNames, getResourcesUniqNames, collectFiles } from '../utils/methods';

export { findNodeIdIndexInArray, findIdIndexInArray, getResourcesFileNames, getResourcesUniqNames, collectFiles };

export default defineNuxtPlugin((nuxtApp: NuxtApp) => {
  nuxtApp.provide('findNodeIdIndexInArray', findNodeIdIndexInArray);
  nuxtApp.provide('findIdIndexInArray', findIdIndexInArray);
  nuxtApp.provide('getResourcesFileNames', getResourcesFileNames);
  nuxtApp.provide('getResourcesUniqNames', getResourcesUniqNames);
  nuxtApp.provide('collectFiles', collectFiles);
});
